"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcTextTruncate = void 0;
var react_1 = __importStar(require("react"));
var react_truncate_markup_1 = __importDefault(require("react-truncate-markup"));
var AcTextTruncate = function (props) {
    var text = props.text, _a = props.maxLines, maxLines = _a === void 0 ? 1 : _a, _b = props.maxWidth, maxWidth = _b === void 0 ? 200 : _b, append = props.append, children = props.children;
    var ellipsis = react_1.default.createElement("i", { className: "fal fa-ellipsis-h fa-fw" });
    var _c = __read(react_1.useState(false), 2), isTruncate = _c[0], setIsTruncate = _c[1];
    return (react_1.default.createElement("div", { className: "d-flex pr-1", style: {
            width: maxWidth === '100%' ? maxWidth : maxWidth + "px",
        } },
        (!!children || !!text) && (react_1.default.createElement(react_truncate_markup_1.default, { lines: maxLines, onTruncate: function (wasTruncated) { return setIsTruncate(wasTruncated); }, ellipsis: react_1.default.createElement("span", { className: "position-relative", style: { zIndex: 1 } },
                ellipsis,
                append) },
            react_1.default.createElement("div", null, children || text))),
        !isTruncate && react_1.default.createElement("span", { className: "ml-auto mt-auto" }, append)));
};
exports.AcTextTruncate = AcTextTruncate;
exports.AcTextTruncate.displayName = 'AcTextTruncate';
//# sourceMappingURL=AcTextTruncate.js.map